import StarRating from "Pages/Faculties/StarRating";
import styled from "styled-components";
const Div1 = styled<any>("div")`
  color: var(--Grey-80, #333);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
const Div2 = styled<any>("div")`
  color: var(--Grey-80, #333);
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px; /* 133.333% */
  margin-bottom: 8px;
`;
const OverrallRating = ({ ratingValue }: any) => {
  return (
    <>
      <Div1>Overall rating</Div1>
      <Div2>{ratingValue === 0 ? "NA" : ratingValue}</Div2>
      <StarRating rating={ratingValue} />
    </>
  );
};
export default OverrallRating;
